import React, { useContext } from 'react';
import { compact } from 'lodash';

import { Icon } from 'ui';
import { routes } from 'constants/config';
import { FilterContext } from 'components/shared/FilterContext';
import DataCard from '../_shared/DataCard';

export default function CertificationsReport() {
  const { params: filter } = useContext(FilterContext);
  const withFilterQuery = url => compact([url, $.param(filter)]).join('?');
  return (
    <DataCard.Container direction="column">
      <DataCard.Content
        title={t('insights.certifications.report.title')}
        subtitle={t('insights.certifications.report.subtitle')}
        labsBadgeDescription={t('insights.more_reports.description')}
      >
        <a
          href={withFilterQuery(routes.INSIGHTS.CERTIFICATION_REPORT)}
          className="DataCard-link"
        >
          <Icon name="download" /> {t('common.download')}
        </a>
      </DataCard.Content>
    </DataCard.Container>
  );
}
